import { Router, Routes, UrlTree } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { redirectGuard } from './redirect.guard';

// export class RedirectGuard {
//   constructor(private router: Router) {}
//   canActivate(routeSnapshot: { data: { redirectTo: string | UrlTree } }) {
//     this.router.navigateByUrl(routeSnapshot.data.redirectTo, {
//       skipLocationChange: true,
//     });
//   }
// }
export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',

    pathMatch: 'full',
  },

  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'error',

    loadComponent: () =>
      import('./error-page/error-page.component').then(
        (c) => c.ErrorPageComponent
      ),
    // canActivate: [redirectGuard],
  },
  {
    path: 'error-data',

    loadComponent: () =>
      import('./error/error.component').then((c) => c.ErrorComponent),
    // canActivate: [redirectGuard],
  },
  {
    path: 'success',

    loadComponent: () =>
      import('./success/success.component').then((c) => c.SuccessComponent),
    // canActivate: [redirectGuard],
  },
  {
    path: 'collapse',

    loadComponent: () =>
      import('./collapse/collapse.component').then((c) => c.CollapseComponent),
    // canActivate: [redirectGuard],
  },
  {
    path: 'creditIncrease',

    loadComponent: () =>
      import('./credit-increase/credit-increase.component').then(
        (c) => c.CreditIncreaseComponent
      ),
    // canActivate: [redirectGuard],
  },
];
